import ActionType from '../ActionType'
import { addContactsToGroup, removeContactsFromGroup } from './groups'

export const openAddDetailsModal = () => (dispatch) =>
	dispatch({ type: ActionType.Contacts.OPEN_ADD_DETAILS_MODAL })

export const closeAddDetailsModal = () => (dispatch) =>
	dispatch({ type: ActionType.Contacts.CLOSE_ADD_DETAILS_MODAL })

export const toggleAddDetailsModal = () => (dispatch) =>
	dispatch({ type: ActionType.Contacts.TOGGLE_ADD_DETAILS_MODAL })

export const handleDefaultFieldChange = (name, value) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.HANDLE_DEFAULT_FIELD_CHANGE,
		payload: { name, value },
	})

export const handleCustomAttributeChange =
	(name, type, value) => (dispatch) => {
		const resolvedValue = type === 'N' ? parseInt(value, 10) : value
		return dispatch({
			type: ActionType.Contacts.HANDLE_CUSTOM_ATTRIBUTE_CHANGE,
			payload: { name, type, value: resolvedValue },
		})
	}

export const handleFieldChange = (index, value, fieldType) => (dispatch) => {
	return dispatch({
		type: ActionType.Contacts.HANDLE_FIELD_CHANGE,
		payload: { index, value, fieldType },
	})
}

export const receiveContact = (payload) => (dispatch) =>
	Promise.resolve(
		dispatch({
			type: ActionType.Contacts.RECEIVE_CONTACT,
			payload,
		}),
	)

export const handleCheckboxChange = (name, checked) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.HANDLE_CHECKBOX_CHANGE,
		payload: { name, checked },
	})
// this.setState({ [name]: event.target.checked })

export const handleModalFieldChange = (name, value) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.HANDLE_FIELD_MODAL_CHANGE,
		payload: { name, value },
	})

export const addCustomFields = (payload) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.ADD_CUSTOM_FIELDS,
		payload,
	})

export const closeBulkUploadDialog = () => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.CLOSE_BULK_UPLOAD_DIALOG,
	})

export const openBulkUploadDialog = () => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.OPEN_BULK_UPLOAD_DIALOG,
	})

export const focusParagraph = () => (dispatch) =>
	dispatch({
		type: ActionType.SmartNotes.FOCUS,
	})

export const blurTextField = () => (dispatch) =>
	dispatch({
		type: ActionType.SmartNotes.BLUR,
	})

export const toggleCustomFieldHover = (customAttribute) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.TOGGLE_CUSTOM_FIELD_HOVER,
		payload: customAttribute,
	})

export const removeCustomAttribute = (customAttribute) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.REMOVE_CUSTOM_ATTRIBUTE,
		payload: customAttribute,
	})

export const openMultiMessageDialog = (contact) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.OPEN_MULTI_MESSAGE_DIALOG,
		payload: contact,
	})

export const closeMultiMessageDialog = (contact) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.CLOSE_MULTI_MESSAGE_DIALOG,
	})

export const openCreateOrUpdateGroupDialog = () => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.OPEN_CREATE_OR_UPDATE_GROUP_DIALOG,
	})

export const closeCreateOrUpdateGroupDialog = () => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.CLOSE_CREATE_OR_UPDATE_GROUP_DIALOG,
	})

export const createGroup = (title) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.CREATE_GROUP,
		payload: title,
	})

export const updateGroup = (title, groupID) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.UPDATE_GROUP,
		payload: { title, groupID },
	})

export const deleteGroup = (groupID) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.DELETE_GROUP,
		payload: groupID,
	})

export const handleGroupModalFieldChange = (value) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.HANDLE_GROUP_MODAL_FIELD_CHANGE,
		payload: value,
	})

export const toggleSelectedContactsMenu = () => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.TOGGLE_SELECTED_CONTACTS_MENU,
	})

export const selectContact = (contact, checked) => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.SELECT_CONTACT,
		payload: { contact, checked },
	})

export const deselectAllContacts = () => (dispatch) =>
	dispatch({
		type: ActionType.Contacts.DESELECT_ALL_CONTACTS,
	})

export const toggleBottomNav = (payload) => (dispatch) =>
	dispatch({ type: ActionType.Contacts.TOGGLE_BOTTOM_NAV, payload })

export const toggleBottomMenu = () => (dispatch) =>
	dispatch({ type: ActionType.Contacts.TOGGLE_BOTTOM_MENU })

export const handleAddField = (payload) => (dispatch) =>
	dispatch({ type: ActionType.Contacts.HANDLE_ADD_FIELD, payload })

export const handleGroupChange =
	(payload, actionObj) => (dispatch, getState) => {
		dispatch({
			type: ActionType.Contacts.HANDLE_GROUP_CHANGE,
			payload,
			actionObj,
		})
		const contactID = getState().addOrEditContact.contactID

		if (contactID !== 'new') {
			if (actionObj.action === 'select-option') {
				dispatch(
					addContactsToGroup({ [contactID]: true }, actionObj.option.groupID),
				)
			} else if (
				actionObj.action === 'remove-value' ||
				actionObj.action === 'pop-value'
			) {
				dispatch(
					removeContactsFromGroup(
						{ [contactID]: true },
						actionObj.removedValue.groupID,
					),
				)
			}
		}
	}

export const handleGroupSuggestionClick = (payload) => (dispatch, getState) => {
	const contactID = getState().addOrEditContact.contactID

	if (contactID !== 'new') {
		dispatch(
			addContactsToGroup({ [contactID]: true }, payload.groupID, payload.label),
		)
	}

	return dispatch({
		type: ActionType.Contacts.HANDLE_GROUP_SUGGESTION_CLICK,
		payload,
	})
}

export const createTaskWithContact = (payload) => (dispatch) =>
	dispatch({ type: ActionType.Contacts.CREATE_TASK_WITH_CONTACT, payload })

export const ingestPrediction = (payload) => (dispatch, getState) => {
	dispatch({ type: ActionType.Contacts.INGEST_PREDICTION, payload })
}
